import React from 'react';
import { Outlet } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

// 1. Accept onLogout as a prop here
const DashboardLayout = ({ onLogout }) => {
  return (
    // The dark class will be managed by the PageHeader toggle
    <div className="min-h-screen bg-slate-50 dark:bg-[#0a0a0a] text-slate-900 dark:text-white font-sans transition-colors duration-500 flex flex-col">
      
      {/* 2. Now it can successfully pass it down to the PageHeader */}
      <PageHeader onLogout={onLogout} />
      
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;